import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/Button';
import { Container } from '../../components/ui/Container';
import { GeometricAccent } from '../../components/ui/GeometricAccent';
import { MosqueArchMask } from '../../components/ui/MosqueArchMask';
import { PatternDecor } from '../../components/ui/PatternDecor';
type PartnerGroup = {
  title: string;
  body: string;
  tone: string;
};
const opportunities = [{
  title: 'التطوير المشترك للمنظومات التعليمية',
  body: 'تصميم مشترك وتوسّع لمنصات تعليمية مبتكرة تصل بين القيم الراسخة والمعايير المهنية المعاصرة.'
}, {
  title: 'التعاون في البحث والمنهجيات',
  body: 'تطوير علم الاندماج وحفظ الهوية عبر بحوث قائمة على البيانات ونماذج تعليمية محكّمة.'
}, {
  title: 'تمكين رأس المال البشري',
  body: 'تنفيذ برامج تدريبية واسعة النطاق تعزز الحراك المهني والمشاركة المدنية والاستقرار المجتمعي طويل الأجل.'
}, {
  title: 'التواصل الثقافي والمدني الاستراتيجي',
  body: 'تطوير مبادرات وصول عالمية تعزز الوعي الثقافي وتحفظ التراث وتقوّي قدرة المجتمعات على الصمود.'
}, {
  title: 'نماذج تمويل ووقف مبتكرة',
  body: 'الشراكة في هياكل استثمار اجتماعي مستدامة، مثل الوقف، لضمان الأثر الدائم واستمرارية الموارد.'
}, {
  title: 'التنفيذ الإقليمي والمناصرة',
  body: 'توظيف بنيتنا التحتية القائمة لتوسيع التدخلات التعليمية المثبتة عبر سياقات عالمية متنوعة.'
}];
const partnerGroups: PartnerGroup[] = [{
  title: 'المؤسسات والمنظمات غير الحكومية',
  body: 'جهات تركز على التعليم ومرونة الأسرة وتنمية المجتمع.',
  tone: 'bg-sage-100'
}, {
  title: 'المؤسسات التعليمية',
  body: 'المدارس والجامعات والجهات البحثية التي تشاركنا التزاماتنا.',
  tone: 'bg-[#F7EDE9]'
}, {
  title: 'الخبراء والمستشارون',
  body: 'متخصصون في التعليم ونمو الطفل والأخلاقيات والدراسات الإسلامية.',
  tone: 'bg-sand-100'
}, {
  title: 'منظمات المجتمع',
  body: 'جهات تخدم الأسر المسلمة في الدول غير المسلمة بحضور مباشر في الميدان.',
  tone: 'bg-[#EDF2F7]'
}];
export function ArabicBecomeAPartner() {
  return <div dir="rtl" className="overflow-hidden text-right" data-id="element-4525" data-mp="8t4phpxsruhy">
      <section className="relative isolate overflow-hidden" data-id="element-4526" data-mp="8smvkzylxsd7">
        <GeometricAccent variant="arabesque" className="absolute -right-20 top-6 hidden h-[420px] w-[420px] md:block" opacity={0.08} data-id="element-4527" data-mp="3q0hzochwspn4" />
        <GeometricAccent variant="dots" className="absolute left-8 top-16 h-32 w-32" opacity={0.4} data-id="element-4528" data-mp="3uyrxyvyxk6cy" />
        <Container className="relative pb-16 pt-8 md:pb-24 md:pt-12" data-id="element-4529" data-mp="3h7ws7sjqa5dl">
          <div className="grid items-center gap-10 lg:grid-cols-12" data-id="element-4530" data-mp="3m0q02pahtttw">
            <motion.div initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            ease: [0.22, 1, 0.36, 1]
          }} className="lg:col-span-6" data-id="element-4531" data-mp="37bk3l931ihpp">
              <p className="text-sm font-semibold text-forest-700" data-id="element-4532" data-mp="3c7sbc1ewr8mu">مسؤولية مشتركة لأثر مشترك</p>
              <h1 className="mt-3 font-display text-4xl font-semibold leading-[1.45] text-ink-900 sm:text-5xl lg:text-[3.5rem]" data-id="element-4533" data-mp="2ycpy0t7qeh00">كن شريكًا</h1>
              <div className="mt-6 max-w-xl space-y-3 text-base leading-loose text-ink-700 md:text-lg" data-id="element-4534" data-mp="2jmvcjl05di24">
                <p data-id="element-4535" data-mp="2eplpgc08dihg">نرحب بالشراكات مع المنظمات والخبراء والمؤسسات التي تشاركنا الالتزام بالتعليم ومرونة الأسرة والمسؤولية الأخلاقية والأثر المجتمعي طويل الأجل.</p>
                <p data-id="element-4536" data-mp="2np8fk1nif1v7">نتعاون مع من يمنحون المسؤولية والاستدامة والنتائج القابلة للقياس أولوية حقيقية.</p>
              </div>
              <div className="mt-8 flex flex-wrap gap-3" data-id="element-4537" data-mp="32lzg4e8x6jme">
                <Link to="/ar/contact#general-inquiry" data-id="element-4538" data-mp="32kel6nip0yo0"><Button variant="primary" size="lg" data-id="element-4539" data-mp="2xny1c5ij16gq">تقدّم للشراكة</Button></Link>
                <Link to="/ar/contact#general-inquiry" data-id="element-4540" data-mp="3beta7ht0znkb"><Button variant="secondary" size="lg" data-id="element-4541" data-mp="3bdrpelm7jmpe">تواصل معنا</Button></Link>
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            scale: 0.96
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.7,
            delay: 0.1,
            ease: [0.22, 1, 0.36, 1]
          }} className="relative lg:col-span-6" data-id="element-4542" data-mp="37dr88t7q4xen">
              <div className="relative aspect-[200/148] w-full lg:-mr-8 lg:w-[calc(100%+6rem)]" data-id="element-4543" data-mp="3gfqtjxprunne"><MosqueArchMask src="https://cdn.magicpatterns.com/uploads/8SGVS9rHr65THgxC24jS6h/Become-Partner-3.jpg" alt="مربّيتان مسلمتان تقرآن قصصًا للأطفال في حديقة مشرقة" data-id="element-4544" data-mp="49uwqijkkm0a" /></div>
            </motion.div>
          </div>
        </Container>
      </section>

      <section className="relative isolate overflow-hidden bg-sage-50/60 py-16 md:py-24" data-id="element-4545" data-mp="i1rim4un9zo8">
        <PatternDecor side="right" y="top" size="lg" data-id="element-4546" data-mp="3hh63oriasfo2" />
        <Container data-id="element-4547" data-mp="3hiqvi9d89ki8">
          <h2 className="font-display text-3xl font-semibold leading-[1.45] text-ink-900 md:text-5xl" data-id="element-4548" data-mp="3hj93225cbl5g">فرص الشراكة</h2>
          <p className="mt-5 max-w-5xl leading-loose text-ink-700" data-id="element-4549" data-mp="3qhufrgo4s5yb">تتوافق رؤيتنا الاستراتيجية مع القادة العالميين في تنمية رأس المال البشري. ونقدم أطرًا تعاونية تركز على النمو المستدام والأثر المجتمعي:</p>
          <ul className="mt-10 max-w-6xl space-y-7" data-id="element-4550" data-mp="15rlt4frhrc5b">{opportunities.map(opportunity => <li key={opportunity.title} className="flex items-start gap-3 text-ink-700 md:gap-4" data-id="element-4551" data-mp="15tpx0xpe4b5l"><CheckCircle2Icon size={18} className="mt-1 shrink-0 text-forest-700" strokeWidth={1.8} aria-hidden="true" data-id="element-4552" data-mp="1aovi5uayxlsm" /><div data-id="element-4553" data-mp="2vatugkxzxw8i"><h3 className="font-display text-lg font-semibold leading-loose text-ink-900" data-id="element-4554" data-mp="2vatsifefrm5v">{opportunity.title}</h3><p className="mt-1.5 text-sm leading-loose" data-id="element-4555" data-mp="2qbqxlns66wbm">{opportunity.body}</p></div></li>)}</ul>
        </Container>
      </section>

      <section className="bg-white/60 py-16 md:py-24" data-id="element-4556" data-mp="2gk4k1ksd0l5p">
        <Container data-id="element-4557" data-mp="2gjkyzv7exgng">
          <h2 className="font-display text-3xl font-semibold leading-[1.45] text-ink-900 md:text-5xl" data-id="element-4558" data-mp="2gi0cmsv9540o">من نتعاون معهم</h2>
          <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-4559" data-mp="27jg4umr8cer8">{partnerGroups.map((group, index) => <PartnerGroupCard key={group.title} group={group} index={index} data-id="element-4560" data-mp="22k3hm0wg55o4" data-mpi={index} />)}</div>
        </Container>
      </section>

      <section className="relative isolate overflow-hidden bg-[#EDF2F7]/60 py-16 md:py-24" data-id="element-4561" data-mp="1xlidvrhzk3ux">
        <PatternDecor side="left" y="middle" size="md" data-id="element-4562" data-mp="sgp1uwwp2pj" />
        <Container data-id="element-4563" data-mp="rxcyutxt8jf">
          <h2 className="font-display text-2xl font-semibold leading-[1.45] text-ink-900 md:text-4xl" data-id="element-4564" data-mp="qch91vvzjjz">كيف تتقدّم</h2>
          <p className="mt-5 max-w-4xl leading-loose text-ink-700" data-id="element-4565" data-mp="1qa40wovyeu1q">تواصل معنا مع نبذة موجزة عن منظمتك ومجال الاهتمام الذي ترغب في العمل فيه. سنرد بالخطوات التالية، بما في ذلك نبذة للشركاء ومكالمة تعريفية.</p>
        </Container>
      </section>

      <section className="relative isolate overflow-hidden bg-white/60 py-16 md:py-24" data-id="element-4566" data-mp="1gd954dr2f7r5">
        <PatternDecor side="right" y="bottom" size="md" data-id="element-4567" data-mp="1lbj12qkm6cdt" />
        <Container data-id="element-4568" data-mp="290lflpjybp43">
          <div className="flex flex-col gap-8 md:flex-row md:items-end md:justify-between" data-id="element-4569" data-mp="2902872rxgj4b">
            <div className="max-w-xl" data-id="element-4570" data-mp="2dzycz48g8ekx"><h2 className="font-display text-3xl font-semibold leading-[1.45] text-ink-900 md:text-5xl" data-id="element-4571" data-mp="2dy3s1px6gmgu">هل أنت مستعد للدعم؟</h2><p className="mt-5 leading-loose text-ink-700" data-id="element-4572" data-mp="1zz45qox50jnu">اختر الخيار الأنسب: التبرع أو المنح الدراسية أو الشراكة المؤسسية. سنرد سريعًا بالخطوات التالية.</p></div>
            <div className="flex flex-wrap gap-3" data-id="element-4573" data-mp="ok8oqwb0q644"><Link to="/ar/partnership/donate-for-children" data-id="element-4574" data-mp="oj717sctfr5i"><Button variant="primary" data-id="element-4575" data-mp="sltuzyt1rm5c">تبرّع</Button></Link><Link to="/ar/contact#general-inquiry" data-id="element-4576" data-mp="snn4rmyyimhk"><Button variant="secondary" data-id="element-4577" data-mp="l2kms8wa1thv">تواصل معنا</Button></Link></div>
          </div>
        </Container>
      </section>
    </div>;
}
function PartnerGroupCard({
  group,
  index
}: {
  group: PartnerGroup;
  index: number;
}) {
  return <motion.article initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.5,
    delay: index * 0.06
  }} className={`rounded-2xl border border-ink-900/5 p-6 shadow-soft ${group.tone}`} data-id="element-4578" data-mp="v10g8iis1euj"><h3 className="font-display text-lg font-semibold leading-loose text-ink-900" data-id="element-4579" data-mp="29qjic80npth">{group.title}</h3><p className="mt-3 text-sm leading-loose text-ink-700" data-id="element-4580" data-mp="3tg9txq9xxdr9">{group.body}</p></motion.article>;
}